import CreditNoteCard from "@molecules/ObjectCard/ObjectCards/CreditNoteCard/CreditNoteCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function CreditNoteCardsView() {
    return (
        <CardsView.List<CreditNote>>
            {(creditNote, displayedAttributes, cardProps) => (
                <CreditNoteCard creditNote={creditNote} displayedAttributes={displayedAttributes} {...cardProps} />
            )}
        </CardsView.List>
    )
}
